import script from "./CourseSessionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseSessionForm.vue?vue&type=script&setup=true&lang=js"

import "./CourseSessionForm.vue?vue&type=style&index=0&id=3907c09a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3907c09a"]])

export default __exports__